export type ReaderRoute = { nome: 'biblioteca' } | { nome: 'avaliacoes' } | { nome: 'leitor'; assetId: string }

export function readReaderRoute(hash: string): ReaderRoute {
  if (hash === '#/tarefas') return { nome: 'avaliacoes' }
  const match = /^#\/livros\/([a-zA-Z0-9-]+)\/leitor$/.exec(hash)
  if (match?.[1]) return { nome: 'leitor', assetId: match[1] }
  return { nome: 'biblioteca' }
}

export function readerRouteHash(route: ReaderRoute): string {
  if (route.nome === 'avaliacoes') return '#/tarefas'
  if (route.nome === 'leitor') return `#/livros/${encodeURIComponent(route.assetId)}/leitor`
  return '#/inicio'
}
